/**
 * inline-help-link.js
 */

import React from 'react';
import { Link } from '@mui/material';
import Icon from 'components/icon';


export default function InlineHelpLink(props) {
  const { intercomId, onClick } = props;

  const handleClick = () => {
    onClick
      ? onClick()
      : window.Intercom('showArticle', intercomId);
  };

  return (
    <Link
      children={<><Icon type='help' sx={{ fontSize: 'sizes.4' }} />&nbsp;LEARN MORE</>}
      onClick={handleClick}
      underline="hover"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        verticalAlign: 'middle',
        marginLeft: 1,
        fontSize: 'sizes.1',
        fontWeight: 'fontWeightBold',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
      }}
    />
  );
}